import React, {createContext, useContext, useMemo} from 'react'

interface FlowContextState {
  terminalNodeId: string
}

const FlowContext = createContext<FlowContextState | undefined>(undefined)

export const useFlowContext = (): FlowContextState => {
  const context = useContext(FlowContext)
  if (!context) throw new Error('useFlowContext must be used within a FlowProvider')
  return context
}

interface FlowProviderProps {
  terminalNodeId: string
  children: React.ReactNode
}

export const FlowProvider: React.FC<FlowProviderProps> = ({terminalNodeId, children}) => {
  const value = useMemo(() => ({terminalNodeId}), [terminalNodeId])
  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>
}
